import { lazy } from 'react'

export const Height = lazy(() => import('./v1/Height'))
export const HeightV2 = lazy(() => import('./v2/HeightV2'))
export const HeightV3 = lazy(() => import('./v3/HeightV3'))
export const HeightV4 = lazy(() => import('./v4/HeightV4'))
